export default __webpack_public_path__ + "static/stooping-83cd406dde6b0f286c4e2bf71e2ecea0.svg";